// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextWednesday as fn } from "../nextWednesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextWednesday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default nextWednesday;
